import { Search, VisibilityRounded, CloseRounded as CloseIcon, Edit } from "@mui/icons-material";
import dayjs from '../../utils/dayjs-setup';
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, GridLegacy as Grid, IconButton, Input, Modal, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { useState, useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel, CheckBoxWithLabel, CustomAutoComplete, InputWithLabel, SelectInputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, DialogType, EntityStatus, FormActions, FormatPrice, generateCodSobreCosto, getLabelMunicipio, RutaEntity, TiposVehiclos, TipoVehiculoEntity } from "../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../components/form/ModalForm";
import { SubItemTable } from "../../components/table/table-components";








/* 
const ModalDetalleProducto = ({
  isVisible,
  Criterios=[],
  productName,
  unidad_medida,
  OnCloseModalDetalle
})=>{

  const [criteriosOrdered,setCriteriosOrdered] = useState([]);
  const [isVisbleModalForm,setIsVisibleModalForm] = useState(false);
  const [itemSeleccionado,setItemSeleccionado] = useState(TipoVehiculoEntity);


  useEffect(()=>{

    OrderDataToPrint();
  },[Criterios]);

  let OrderDataToPrint = ()=>{
   let NuevosCriterios = [];
    console.log({Criterios});
   const IsKeyInList = (key)=>{

   return  NuevosCriterios.findIndex( Ncriterio => Ncriterio.label === key );
  }
  Criterios.forEach(crt=>{
      let IndexItem = IsKeyInList(crt.descripcion_plan) ;
    if ( IndexItem !== -1){

      NuevosCriterios[IndexItem].SubItems.push({
        label:crt.descripcion_plan,
        value:`${crt.cod_mayor}+${crt.cod_plan}`
      });

    }else{

      NuevosCriterios.push({
        key:`${crt.descripcion_plan}-${crt.cod_mayor}-${crt.cod_plan}`,
        label:String(crt.descripcion_plan).toLowerCase(),
        SubItems:[{
          label:crt.descripcion_mayor,
          value:`${crt.cod_mayor}+${crt.cod_plan}`
        }]
      });

    }

  });
  setCriteriosOrdered(NuevosCriterios);
  console.log({NuevosCriterios});
  }

  return (
    <Dialog
     open={isVisible}
     maxWidth="md"
    >
      <DialogTitle sx={{ m: 0, p: 2 }} >
      <Grid container >
        <Grid item sm={10} md={10}  >
          <Typography variant="h6"  alignContent="center" textAlign="left" >
              {productName} {unidad_medida? '- '+unidad_medida:''}
        </Typography>
      </Grid>
        <Grid item sm={2} md={2} alignContent="center" textAlign="center" >
          <IconButton
            aria-label="close"
            onClick={OnCloseModalDetalle}
            sx={{
              fontWeight:"bold",
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      
    </DialogTitle>
    <DialogContent>
          <Grid container >
            <Grid  item sx={12} md={12} >
             <Typography variant="subtitle1" >
                Criterios de clasificacion
             </Typography>
            </Grid>
            <Grid container item sx={12} md={12} >
              {
                criteriosOrdered.map( criterioOrdered=> <Grid key={criterioOrdered.key} item sm={4} md={4} >
                      <CustomAutoComplete
                       multiple
                       disabled
                       id="tags-standard"
                       options={criterioOrdered.SubItems}
                       getOptionLabel={(option) => option.label}
                       isOptionEqualToValue={(option,value)=>{
                       
                        
                        return option.value === value.value;
                       }}
                       defaultValue={criterioOrdered.SubItems}
                       renderInput={(params) => (
                         <TextField
                         
                           {...params}
                           variant="standard"
                           label={criterioOrdered.label}
                          
                         />
                       )}
                      />
                  </Grid> )
              }
             
            </Grid>
          </Grid>

        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={OnCloseModalDetalle} >OK, Cerrar</Button>
        </DialogActions>
    </Dialog>
  )

} */









const schema = yup.object({
  municipio_origen: yup.object().required(),
  municipio_destino: yup.object().required(),
 


}).required();
const InitialFilterSearch = {
  rows_per_page: 20,
  page_number: 0,
  filter_search: ""
};

export const MaestroSobreCosto = () => {

  const [dataSetProdctos, setDataSetProductos] = useState([]);
  const [filterSearchPagination, setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows, setTotalRows] = useState(0);
  const { dispatch, store } = useContext(AppContext);
  const [isVisibleModalDetalle, setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado, setProductoSeleccionado] = useState({ ...RutaEntity });
  const [tipoAction, setTipoAction] = useState(FormActions.AGREGAR);
  const [municipiosOptions, setMunicipiosOptions] = useState({ origen: [], destino: [] });
  const [isOpenedAutoComplete, setIsOpenedAutoComplete] = useState([]);
  const [isLoadingAutoComplete, setIsLoadingAutoComplete] = useState(false);
  const [tiposSobreCostos,setTiposSobreCostos] = useState([]);



  useEffect(() => {

    loadItems();
    loadListadoTipoSobreCostos();

  }, []);


  useEffect(() => {

    loadItems(filterSearchPagination.filter_search ? false : true);
  }, [filterSearchPagination]);
  const loadItems = async (loading = true) => {
    setDataSetProductos([]);
    if (loading) {
      dispatch({
        type: ActionTypes.setLoadingPage,
        data: true
      });
    }

    let { data: { value } } = await AxiosInstance.post("maestros/obtener-sobrecostos-paginacion", {
      ...filterSearchPagination,
      page_number: filterSearchPagination.page_number + 1
    });
    setDataSetProductos([...value.data.map(item=>({...item,cod:generateCodSobreCosto(item)}))]);

    setTotalRows(value.total);
    dispatch({
      type: ActionTypes.setLoadingPage,
      data: false
    });

  }
  const loadListadoTipoSobreCostos = async()=>{

     let {data:{value}} = await  AxiosInstance.get("maestros/obtener-tipos-sobrecostos/RUTA");
     setTiposSobreCostos(value.map(tipo=>({...tipo,valor:0})));

  }

  const handleChangePage = (event, newPage) => {

    setFilterSearchPagination({ ...filterSearchPagination, page_number: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setFilterSearchPagination({ ...filterSearchPagination, rows_per_page: parseInt(event.target.value, 10) });

  };

  const onSearchProductByName = (evt) => {

    setFilterSearchPagination({ ...InitialFilterSearch, filter_search: evt.target.value });
  }

  const onShowDetailProduct = (cod_prod) => {
   
    let product = dataSetProdctos.find(prod => generateCodSobreCosto(prod) === cod_prod);
    console.log({product});
    let dataFormPayload = {}
    dataFormPayload["municipio_destino"] = {
      label:getLabelMunicipio(product.mun_destino.desc_departamento,product.mun_destino.descripcion),
      value:product.mun_destino.cod  }
    dataFormPayload["municipio_origen"] ={
      label:getLabelMunicipio(product.mun_origen.desc_departamento,product.mun_origen.descripcion),
      value:product.mun_origen.cod  }
   
    dataFormPayload["cod"] = cod_prod;
    product.detalle.forEach(ele=>{
      dataFormPayload[  ele.tipo_sobre_costo_desc ] = Number(ele.valor);
    });
    console.log({dataFormPayload});
    setTipoAction(FormActions.MODIFICAR);
 setProductoSeleccionado(dataFormPayload || {});

    
    onOpenModalItem(true);
  }
  const onCloseModalItem = () => {
    setIsVisibleModalDetalle(false);
  }
  const onOpenModalItem = (edit = false) => {
    console.log({ edit });
    if (!edit) {
      setProductoSeleccionado({ ...RutaEntity });
      setTipoAction(FormActions.AGREGAR);
    }
    setIsVisibleModalDetalle(true);
  }
  const onSaveDataForm = async (typeAction, dataForm) => {

    const urlService = typeAction === FormActions.AGREGAR ? 'maestros/crear-sobrecosto' : 'maestros/mod-sobrecosto/';
    console.log({
      typeAction,
      dataForm
    });
 
    setIsVisibleModalDetalle(false);
    dispatch({
      type: ActionTypes.setLoadingPage,
      data: true
    });
   
    if (FormActions.AGREGAR === typeAction){
      try{

        await  Promise.all( tiposSobreCostos.map( async(tipo_sobre)=>{
          let payload = {};  
          let valueSobreCosto = dataForm[tipo_sobre.descripcion];
          if (!valueSobreCosto){
            return;
          } 
          
          payload['cod_municipio_origen'] = dataForm.municipio_origen.value; 
          payload['cod_municipio_destino'] = dataForm.municipio_destino.value; 
          payload['cod_tipo_sobrecosto'] = tipo_sobre.cod;
          payload['fecha_desde'] = dayjs().format("YYYY-MM-DD");
          payload['valor'] = valueSobreCosto;
  
          await  AxiosInstance.post(urlService, payload);
    
         }) );
         dispatch({
          type: ActionTypes.setLoadingPage,
          data: false
        });
       await loadItems();
       

      
       
      }catch(e){
        dispatch({
          type: ActionTypes.setModalInfo,
          data: {
            title: "Error",
            message: "Error de comunicacion verifique su conexion a internet",
            type: DialogType.peligro,
            isVisible: true
          }
        });
      }
   

    }else{
      
      try{

        await  Promise.all( tiposSobreCostos.map( async(tipo_sobre)=>{
          let payload = {};  
          let valueSobreCosto = dataForm[tipo_sobre.descripcion];
          if (!valueSobreCosto){
            return;
          } 
          const Registro =  dataSetProdctos.find(prod => generateCodSobreCosto(prod) === dataForm.cod);
          const SobreCostoReg = Registro.detalle.find(det=>det.tipo_sobre_costo_cod === tipo_sobre.cod );
          console.log({Registro,SobreCostoReg,tipo_sobre});
        
          const customUrl = !SobreCostoReg? 'maestros/crear-sobrecosto' : 'maestros/mod-sobrecosto/'+SobreCostoReg.cod;
          payload['cod_municipio_origen'] = dataForm.municipio_origen.value; 
          payload['cod_municipio_destino'] = dataForm.municipio_destino.value; 
          payload['cod_tipo_sobrecosto'] = tipo_sobre.cod;
          payload['fecha_desde'] = !SobreCostoReg? dayjs().format("YYYY-MM-DD"):undefined;
          payload['valor'] = valueSobreCosto;
  
          await  AxiosInstance.post(customUrl , payload);
    
         }) );
         await loadItems();
         dispatch({
          type: ActionTypes.setLoadingPage,
          data: false
        });
     
  
       }catch(e){
        console.log(e.message);
        dispatch({
          type: ActionTypes.setLoadingPage,
          data: false
        });
        dispatch({
          type: ActionTypes.setModalInfo,
          data: {
            title: "Error",
            message: "Error de comunicacion verifique su conexion a internet",
            type: DialogType.peligro,
            isVisible: true
          }
        });
       }

    }

   



  }

  const onSearchMunicipio = async (value_search) => {

    if (value_search) {
      const { data: { value } } = await AxiosInstance.post("maestros/get-municipio-filter", {
        search_query: value_search
      })
      return value.map(mun => ({
        label: `${getLabelMunicipio(mun.desc_departamento,mun.descripcion)}`,
        value: mun.cod
      }))

    }



  }

  const searchMunicipiosOrigen = async (event, newInputValue) => {
    try {
      let res = await onSearchMunicipio(newInputValue);
      setMunicipiosOptions({ ...municipiosOptions, origen: res });
    } catch (e) {

    }
  }
const searchMunicipiosDestino = async (event, newInputValue) => {
  try {
    let res = await onSearchMunicipio(newInputValue);
    setMunicipiosOptions({ ...municipiosOptions, destino: res });
  } catch (e) {

  }
}



const columnsTable = [
  {

    key: "mun_origen",
    keyValue: "mun_origen",
    label: "Origen",
    headerRender: (props) => props.label,
    bodyRender: (props) => `${props.value?.desc_departamento} - ${props.value?.descripcion} `,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },

  {

    key: "mun_destino",
    keyValue: "mun_destino",
    label: "Destino",
    headerRender: (props) => props.label,
    bodyRender: (props) => `${props.value?.desc_departamento} - ${props.value?.descripcion} `,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "fecha_desde",
    keyValue: "fecha_desde",
    label: "Fecha",
    headerRender: (props) => props.label,
    bodyRender: (props) => props.value,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "ind_estado",
    keyValue: "ind_estado",
    label: "Activo",
    headerRender: (props) => props.label,
    bodyRender: (props) => EntityStatus[props.value],
    typeRow: "number",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "tipos_sobre_costos",
    keyValue: "detalle",
    label: "Sobrecostos",

    headerRender: (props) => props.label,
    bodyRender: (props) => <SubItemTable
      cols={[{
        label: "Tipo",
        valueKey: "tipo_sobre_costo_desc",
        keyRow: "cod",
       
      },
      {
        label: "Valor",
        valueKey: "valor",
        keyRow: "cod",
        format:FormatPrice
      }
      ]}
      typeView="horizontal"
      items={props.value} />,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },

  {
    key: "editar",
    keyValue: "cod",
    label: "Editar",
    headerRender: (props) => props.label,
    bodyRender: ({ value }) => <Button onClick={e => onShowDetailProduct(value)} variant="contained" startIcon={<Edit />} >Editar</Button>,
    typeRow: "number",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
];



const configModal = {
  titleModal: tipoAction === FormActions.AGREGAR ? "Agregar nueva ruta" : 'Modificar ruta',
  buttomsAction: tipoAction === FormActions.AGREGAR ? [
    {
      title: "Cancelar",
      buttomProps: {
        type: "buttom",
        onClick: () => setIsVisibleModalDetalle(false),
        color: "secondary"
      }
    },
    {
      title: "Registrar",
      buttomProps: {
        type: "submit",
        // onClick:onSaveDataNewData
      }
    }
  ] : [
    {
      title: "Cancelar",
      buttomProps: {
        type: "buttom",
        color: "secondary",
        onClick: () => setIsVisibleModalDetalle(false)
      }
    },
    {
      title: "Guardar cambios",
      buttomProps: {
        type: "submit",
        //  onClick:onSaveModData
      }
    }

  ],
  imputs: [
    {
      key: "municipio_origen",
      keyValue: "municipio_origen",
      label: "Municipio de Origen",
      component: AutoCompleteInputWithLabel,
      inputProps: {
        name: 'municipio_origen',
        fullWidth: true,
        isLoading: false,
        onInputChange: searchMunicipiosOrigen,
        options: municipiosOptions.origen || [],
        noOptionsText: "Lista vacia",
        getOptionLabel: (option) => option.label,
        isOptionEqualToValue: (option, value) => option.value === value.value,
        filterOptions:(x) => x,
      }
    },
    {
      key: "municipio_destino",
      keyValue: "municipio_destino",
      label: "Municipio de Destino",
      component: AutoCompleteInputWithLabel,
      inputProps: {
        name: 'municipio_destino',
        fullWidth: true,
        isLoading: false,
        onInputChange: searchMunicipiosDestino,
        options: municipiosOptions.destino || [],
        noOptionsText: "Lista vacia",
        getOptionLabel: (option) => option.label,
        isOptionEqualToValue: (option, value) => option.value === value.value,
        filterOptions:(x) => x,
      }
    },
     {
       key:"detalle",
       keyValue:"detalle",
       label:"Sobrecostos",
       generateDinamyc:true,
       component:InputWithLabel,
       ArrayList:tiposSobreCostos,
       ArrayInputsProps:{
        key:"cod",
        keyValue:"descripcion",
        type:"number"
       }
      
     },
   

  ],
  arrayInputs:[]
};

return (<>
  {
    isVisibleModalDetalle &&
    <ModalFormGenerador
      isVisible={isVisibleModalDetalle}
      schemaValidator={schema}
      entityValues={productoSeleccionado}
      {
      ...configModal
      }
      onSendForm={onSaveDataForm}
      typeAction={tipoAction}
    />
  }

  <Grid container spacing={2} >
    {/*         <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar producto"
            
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid> */}
    <Grid item sm={12} xs={12} md={12} >
      <Button variant="contained" color="primary" onClick={e => onOpenModalItem(false)} >Nueva ruta </Button>
    </Grid>
    <Grid item sm={12} xs={12} md={12} >

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>

              {
                columnsTable.map(colum => <TableCell key={colum.key} >
                  {<colum.headerRender label={colum.label} />}
                </TableCell>)
              }

            </TableRow>

          </TableHead>
          <TableBody>

            {dataSetProdctos.map(prod =>
              <TableRow key={prod.cod}  >

                {
                  columnsTable.map(Col =>
                    <TableCell key={Col.key + "-" + prod.cod} >
                      {<Col.bodyRender value={prod[Col.keyValue]} />}
                    </TableCell>)
                }

              </TableRow>
            )}

          </TableBody>

        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20, 40, 60]}
        component="div"
        count={totalRows}
        rowsPerPage={filterSearchPagination.rows_per_page}
        page={filterSearchPagination.page_number}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

    </Grid>
  </Grid>
</>)

}